import React, { useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { FileUploader } from "react-drag-drop-files";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  verifyBankDetailsApi,
  checkPennyDropBankApi,
  uploadCancelCheque,
  updateBankDetails,
} from "designs/v1/pages/ModifyKyc/services";
import { getReKycBankByIfsc } from "designs/v1/redux/services";
import {
  jsonToFormData,
  validateOnNumber,
  isEmptyObject,
  MARFATIA_API_URL,
  getApiUrl,
} from "utils";
import { handleFileResizer } from "utils/imageResizer";
import WebcamCapture from "designs/v1/pages/ModifyKyc/components/WebcamCapture";

const CreateRequest = ({
  isLoading,
  setIsLoading,
  stageScreen,
  activeUserDetail,
  setStageScreen,
  setStep,
}) => {
  const [showCheckUpload, setShowCheckUpload] = useState(false);
  const [uploadCheckResp, setUploadCheckResp] = useState("");
  const [showWebCam, setShowWebCam] = useState({
    show: false,
    image: "",
  });
  const timeout = useRef();
  const initialValues = {
    account_type: "Saving",
    account_no: "",
    ifsc: "",
    bank_name: "",
    branch_name: "",
    micr_code: "",
  };
  const chequeInitialValues = {
    account_type: "",
    acc_name: "",
    acc_no: "",
    ifsc_code: "",
    bank_name: "",
    branch: "",
  };
  const validationSchema = Yup.object().shape({
    account_no: Yup.string()
      .min(11, "Account number should be 11 digit")
      .required("Account number is required."),
    ifsc: Yup.string()
      .min(11, "IFSC Code should be 11 digit")
      .required("IFSC Code is required."),
    // branch_name: Yup.string().required("Branch name is required."),
  });
  const chequeValidationSchema = Yup.object().shape({
    acc_no: Yup.string()
      .min(11, "Account number should be 11 digit")
      .required("Account number is required."),
    ifsc_code: Yup.string()
      .min(11, "IFSC Code should be 11 digit")
      .required("IFSC Code is required."),
    // branch: Yup.string().required("Branch name is required."),
  });
  const IS_UPLOAD = true;

  const handleSubmit = async (value) => {
    let account =
      (activeUserDetail.bank_details?.length > 0 &&
        activeUserDetail.bank_details.filter(
          (item) => item.verified_bank_account === 1
        )) ||
      [];
    const accNo = uploadCheckResp ? value.acc_no : value.account_no;
    const exists = account.some((obj) => obj.verified_account_number === accNo);
    if (exists) {
      return toast.error(
        "Error: This account number already exists. Please enter a new account number.."
      );
    }
    setIsLoading(true);
    if (uploadCheckResp) {
      if (!value.branch) {
        setIsLoading(false);
        return toast.error("Error: Invalid IFSC Code");
      }
      let payload = {
        account_type: value.account_type,
        acc_name: value.acc_name,
        acc_no: value.acc_no,
        bank_name: value.bank_name,
        ifsc_code: value.ifsc_code,
        branch: value.branch,
        doc_name: localStorage.getItem("BankRequestNumber"),
        bank_modification_type: localStorage.getItem("BankRequestType"),
        existing_customer: activeUserDetail.existing_customer,
      };
      try {
        await updateBankDetails(payload);
        setStep("UpdatePrimaryBank");
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        toast.error("Something went wrong. Please try again.");
      }
    } else {
      if (!value.branch_name) {
        setIsLoading(false);
        return toast.error("Error: Invalid IFSC Code");
      }
      let payload = {
        ...value,
        doc_name: localStorage.getItem("BankRequestNumber"),
        existing_customer: activeUserDetail.existing_customer,
      };
      try {
        const bankresp = await verifyBankDetailsApi(payload);
        console.log("bankresp", bankresp);
        setTimeout(async () => {
          try {
            const pennyresp = await checkPennyDropBankApi({
              request_type: stageScreen,
              doc_name: payload.doc_name,
            });
            console.log("pennyresp", pennyresp.data?.data);
            setIsLoading(false);
            if (isEmptyObject(pennyresp.data?.data)) {
              setShowCheckUpload(true);
              return toast.error("Please upload cancelled cheque.");
            }
            if (getApiUrl() === MARFATIA_API_URL) {
              setShowCheckUpload(true);
              return toast.error("Please upload cancelled cheque.");
            }
            setShowCheckUpload(false);
            setStep("UpdatePrimaryBank");
          } catch (error) {
            setIsLoading(false);
            setShowCheckUpload(true);
          }
        }, 40000);
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Something went wrong. Please try again."
        );
        setIsLoading(false);
      }
    }
  };

  const getIfscInfo = async (value, setFieldValue, isUpload = false) => {
    const payload = { ifsc_code: value };
    setIsLoading(true);
    try {
      const resp = await getReKycBankByIfsc(payload);
      const data = resp.data.data;
      if (!data) return;
      console.log("isUpload", isUpload);
      if (isUpload) {
        setFieldValue("bank_name", data.bank_name);
        setFieldValue("branch", data.branch);
      } else {
        setFieldValue("bank_name", data.bank_name);
        setFieldValue("branch_name", data.branch);
        setFieldValue("micr_code", data.micr_code);
      }
      setShowCheckUpload(false);
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      if (isUpload) {
        setFieldValue("bank_name", "");
        setFieldValue("branch", "");
        setFieldValue("ifsc_code", "");
      } else {
        setFieldValue("bank_name", "");
        setFieldValue("branch_name", "");
        setFieldValue("micr_code", "");
      }
      setIsLoading(false);
      setShowCheckUpload(false);
      toast.error("Error: Invalid IFSC Code");
    }
  };

  const handleChequeUpload = async (file, values, setFieldValue) => {
    if (!file) {
      return toast.error("Please upload proof");
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      return toast.error(
        "Only Images/Pdf are allowed ( JPG | PNG | PDF )",
        "Error"
      );
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      toast.error("Please upload a file smaller than 4 MB");
      return;
    }
    if (file.type === "application/pdf") {
      const payload = {
        img: file,
        file_type: "pdf",
        doc_name: localStorage.getItem("BankRequestNumber"),
        request_type: stageScreen,
        existing_customer: activeUserDetail.existing_customer,
      };
      setIsLoading(true);
      try {
        const resp = await uploadCancelCheque(jsonToFormData(payload));
        const data = resp.data.data;
        console.log(data);
        if (isEmptyObject(data)) {
          setIsLoading(false);
          return toast.error("Something went wrong. Please try again.");
        }
        toast.success(resp.data?.message);
        setUploadCheckResp(data);
        setFieldValue("account_type", values.account_type);
        setFieldValue("acc_name", data.acc_name);
        setFieldValue("acc_no", data.acc_no);
        setFieldValue("ifsc_code", data.ifsc_code?.slice(-11));
        getIfscInfo(data.ifsc_code?.slice(-11), setFieldValue, IS_UPLOAD);
        setIsLoading(false);
      } catch (error) {
        console.log("error", error);
        setIsLoading(false);
        toast.error("Something went wrong. Please try again.");
      }
    } else {
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async () => {
        if (img.width >= 400 && img.height >= 350) {
          const newFile = await handleFileResizer(file);
          const payload = {
            img: newFile,
            file_type: "Image",
            doc_name: localStorage.getItem("BankRequestNumber"),
            request_type: stageScreen,
            existing_customer: activeUserDetail.existing_customer,
          };
          setIsLoading(true);
          try {
            const resp = await uploadCancelCheque(jsonToFormData(payload));
            const data = resp.data.data;
            console.log(data);
            if (isEmptyObject(data)) {
              setIsLoading(false);
              return toast.error("Something went wrong. Please try again.");
            }
            toast.success(resp.data?.message);
            setUploadCheckResp(data);
            setFieldValue("account_type", values.account_type);
            setFieldValue("acc_name", data.acc_name);
            setFieldValue("acc_no", data.acc_no);
            setFieldValue("ifsc_code", data.ifsc_code?.slice(-11));
            getIfscInfo(data.ifsc_code?.slice(-11), setFieldValue, IS_UPLOAD);
            setIsLoading(false);
          } catch (error) {
            console.log("error", error);
            setIsLoading(false);
            toast.error("Something went wrong. Please try again.");
          }
        } else {
          return toast.error(
            `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
          );
        }
      };
    }
  };

  const onSearchIfsc = (name, value, setFieldValue, isUpload = false) => {
    setFieldValue(name, value?.toUpperCase());
    if (value.length > 10) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getIfscInfo(value, setFieldValue, isUpload);
      }, 250);
    } else {
      if (isUpload) {
        setFieldValue("bank_name", "");
        setFieldValue("branch", "");
      } else {
        setFieldValue("bank_name", "");
        setFieldValue("branch_name", "");
        setFieldValue("micr_code", "");
      }
    }
  };

  const toggleWebCamModal = () => {
    setShowWebCam((prev) => ({ ...prev, show: !prev.show }));
  };

  const handleWebCamImage = (image, rest) => {
    setShowWebCam((prev) => ({ ...prev, image: image }));
    rest?.setFieldValue("file", image);
  };

  return (
    <div>
      <Title title="Bank Modification Request" />
      <div className="col-md-9 mt-3">
        <div className="ml-2">
          <Formik
            enableReintialize={true}
            initialValues={
              uploadCheckResp ? chequeInitialValues : initialValues
            }
            validationSchema={
              uploadCheckResp ? chequeValidationSchema : validationSchema
            }
            onSubmit={handleSubmit}
          >
            {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
              <Form>
                {uploadCheckResp ? (
                  <>
                    <div className="form-group my-2">
                      <label className="py-1">Account Name</label>
                      <Field
                        type="text"
                        name="acc_name"
                        placeholder="Account Name"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">Account Number</label>
                      <Field
                        type="text"
                        name="acc_no"
                        placeholder="Account Number"
                        className="form-control"
                        onKeyPress={validateOnNumber}
                      />
                      <ErrorMessage
                        name="acc_no"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">IFSC Code</label>
                      <Field
                        type="text"
                        name="ifsc_code"
                        placeholder="IFSC Code"
                        className="form-control"
                        onChange={({ target }) =>
                          onSearchIfsc(
                            "ifsc_code",
                            target.value,
                            setFieldValue,
                            IS_UPLOAD
                          )
                        }
                        maxLength={11}
                      />
                      <ErrorMessage
                        name="ifsc_code"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    <div className="d-flex align-items-center my-1">
                      <label style={{ marginRight: "0.5rem" }}>Bank:</label>
                      <span>{values.bank_name || "-"}</span>
                    </div>
                    <div className="d-flex align-items-center my-1">
                      <label style={{ marginRight: "0.5rem" }}>Branch:</label>
                      <span>{values.branch || "-"}</span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="form-group my-2">
                      <label className="py-1">Account Type</label>
                      <Field
                        as="select"
                        name="account_type"
                        className="form-select"
                        autoFocus={true}
                        disabled={showCheckUpload}
                      >
                        <option value="Saving">Saving</option>
                        <option value="Current">Current</option>
                      </Field>
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">Account Number</label>
                      <Field
                        type="text"
                        name="account_no"
                        placeholder="Account Number"
                        className="form-control"
                        onKeyPress={validateOnNumber}
                        disabled={showCheckUpload}
                      />
                      <ErrorMessage
                        name="account_no"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">IFSC Code</label>
                      <Field
                        type="text"
                        name="ifsc"
                        placeholder="IFSC Code"
                        className="form-control"
                        onChange={({ target }) =>
                          onSearchIfsc("ifsc", target.value, setFieldValue)
                        }
                        maxLength={11}
                        disabled={showCheckUpload}
                      />
                      <ErrorMessage
                        name="ifsc"
                        className="inline-errormsg my-1"
                        component="div"
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">Bank Name</label>
                      <Field
                        type="text"
                        name="bank_name"
                        placeholder="Bank Name"
                        className="form-control"
                        disabled={true}
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">Branch Name</label>
                      <Field
                        type="text"
                        name="branch_name"
                        placeholder="Branch Name"
                        className="form-control"
                        disabled={true}
                      />
                    </div>
                    <div className="form-group my-2">
                      <label className="py-1">MICR Code</label>
                      <Field
                        type="text"
                        name="micr_code"
                        placeholder="MICR Code"
                        className="form-control"
                        disabled={showCheckUpload}
                      />
                    </div>
                  </>
                )}
                {showCheckUpload && (
                  <>
                    <div>
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="py-1">Upload Cheque</label>
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12 file-uploader-container">
                          <FileUploader
                            handleChange={(file) =>
                              handleChequeUpload(file, values, setFieldValue)
                            }
                            name="file"
                            types={["JPG", "JPEG", "PNG", "PDF"]}
                          />
                        </div>
                        {/* <div className="col-md-3 text-end mt-1">
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => toggleWebCamModal()}
                          >
                            Open Camera
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </>
                )}
                <div className="d-flex form-group my-4">
                  <div className="mx-2">
                    <Button
                      type="button"
                      title="Back"
                      handleClick={() => setStep("DematUccForm")}
                    />
                  </div>
                  <div className="mx-2">
                    <Button
                      title="Submit"
                      type={"submit"}
                      disabled={isSubmitting || isLoading}
                    />
                  </div>
                </div>
                <WebcamCapture
                  showModal={showWebCam.show}
                  setShowModal={toggleWebCamModal}
                  image={showWebCam.image}
                  setImage={handleWebCamImage}
                  setFieldValue={setFieldValue}
                />
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CreateRequest;
